import { c as _c } from "react/compiler-runtime";
import CourseActions from 'modules/courses/bundles/course-bundle/components/course-actions';
import { CourseBundleInterface, CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
interface CourseProps {
  item?: CourseBundleItemInterface;
  mutate: KeyedMutator<CourseBundleInterface>;
}
function CourseOverlay(t0) {
  const $ = _c(14);
  const {
    item,
    mutate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  if (!item) {
    return null;
  }
  let t1;
  if ($[0] !== item.course.name) {
    t1 = <div className="text-text-primary text-start flex-[65_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4"><div className="relative flex h-full w-full max-w-fit cursor-pointer items-center gap-2 truncate text-base"><span className="truncate ">{item.course.name}</span></div></div>;
    $[0] = item.course.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.course_bundle.course.delay_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = item.delayBeforeStart || 0;
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="text-text-primary text-start flex-[25_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4"><div><div className="relative flex h-full w-full max-w-fit items-center truncate"><span className="cursor-default truncate">{t2} {t3}</span></div></div></div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== item || $[8] !== mutate) {
    t5 = <div className="text-text-primary font-inter flex-[10_1_0%] truncate px-4 py-2 text-[17px] font-bold lg:px-6 lg:py-4"><CourseActions item={item} mutate={mutate} /></div>;
    $[7] = item;
    $[8] = mutate;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="hover:border-brand-primary main-transition-colors even:bg-brand-primary-subtle odd:bg-background-secondary flex cursor-move flex-col gap-3 border border-transparent first:rounded-t-lg last:rounded-b-lg focus-visible:outline-hidden"><div className="z-0 overflow-hidden rounded-lg"><div className="flex flex-col overflow-hidden rounded-b-lg lg:flex-row lg:items-center">{t1}{t4}{t5}</div></div></div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export default CourseOverlay;